// extracted by mini-css-extract-plugin
export var closeButton = "bZ_gj";
export var dialogWrapper = "bZ_gk";
export var mainContent = "bZ_bd";
export var modalWrapper = "bZ_gh";